// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".full-width[data-v-a0db58ea]{width:calc(100% + 24px);margin-left:-12px}", ""]);
// Exports
module.exports = exports;
